import { render } from "./App.vue?vue&type=template&id=db341cda"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=db341cda&lang=css"

import exportComponent from "C:\\Users\\germa\\dev\\es.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__